<template>
  <div
    class="flex p-10"
    :class="reminder.bgColor"
  >
    <div class="flex items-center mr-16">
      <div class="icon-big">
        <i :class="reminder.icon" />
      </div>
    </div>

    <div class="flex flex-col">
      <p class="text-3xl mb-5">
        <b>{{ reminder.title }}</b>
      </p>

      <p class="text-2xl mb-5">
        Complete by: {{ formatDate(reminder.date) }}
      </p>

      <router-link :to="{ name: 'my@schedule' }">
        <p class="text-2xl mb-5">
          <b>
            Click here to view your schedule
          </b>
        </p>
      </router-link>
    </div>
  </div>
</template>
<script>
import HelperDate from "@helpers/dates";
export default {
  components: {},
  props: {
    reminder: {
      type: Object,
      default: () => {}
    }
  },
  methods: {
    formatDate(date) {
      return HelperDate.formatDate(date);
    }
  }
};
</script>

<style lang="scss"></style>
